import { render } from "./UUIDGenerator.vue?vue&type=template&id=73e42e66&scoped=true"
import script from "./UUIDGenerator.vue?vue&type=script&lang=js"
export * from "./UUIDGenerator.vue?vue&type=script&lang=js"

import "./UUIDGenerator.vue?vue&type=style&index=0&id=73e42e66&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e42e66"]])

export default __exports__